import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
`;
